import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone, Sparkles } from "lucide-react";
import { api } from "../api";
import { useLang } from "../i18n";
import { Reveal } from "./Section";

const telHref = (display) => {
    const digits = String(display).replace(/\D/g, "");
    return `tel:${digits.length === 10 ? "+1" + digits : digits}`;
};

export const VipSection = () => {
    const { t } = useLang();
    const [phones, setPhones] = useState(["407-227-9076", "326-096-36"]);

    useEffect(() => {
        api.get("/payments/config")
            .then((r) => setPhones([r.data.vip_phone_1 || "407-227-9076", r.data.vip_phone_2 || "326-096-36"]))
            .catch(() => {});
    }, []);
    return (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24 sm:pb-32" data-testid="vip-section">
            <Reveal>
                <div className="relative overflow-hidden rounded-3xl border border-lakou-gold/30 bg-lakou-coal/70 px-6 py-12 sm:p-14 text-center">
                    <div className="pointer-events-none absolute -top-24 left-1/2 -translate-x-1/2 w-[480px] h-[480px] rounded-full bg-lakou-gold/10 blur-[120px]" />
                    <div className="relative">
                        <span className="inline-flex items-center gap-2 rounded-full bg-lakou-gold/15 border border-lakou-gold/40 px-4 py-1.5 font-mono2 text-[10px] uppercase tracking-[0.25em] text-lakou-gold" data-testid="vip-eyebrow">
                            <Sparkles size={12} /> {t("vip_eyebrow")}
                        </span>
                        <h2 className="mt-5 font-display font-black text-3xl sm:text-4xl lg:text-5xl text-lakou-cream tracking-tight" data-testid="vip-title">
                            {t("vip_title")}
                        </h2>
                        <p className="mt-4 max-w-xl mx-auto text-sm sm:text-base text-lakou-grey leading-relaxed">{t("vip_sub")}</p>
                        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
                            {phones.map((display, i) => (
                                <motion.a
                                    key={display}
                                    href={telHref(display)}
                                    whileTap={{ scale: 0.97 }}
                                    data-testid={`vip-call-${i}`}
                                    className="inline-flex items-center gap-3 rounded-full bg-lakou-orange hover:bg-lakou-gold text-white hover:text-lakou-ink font-display font-bold text-sm sm:text-base tracking-[0.08em] px-8 py-4 transition-colors duration-300"
                                >
                                    <Phone size={17} /> {display}
                                </motion.a>
                            ))}
                        </div>
                        <p className="mt-5 font-mono2 text-[10px] uppercase tracking-[0.25em] text-lakou-sand">{t("vip_note")}</p>
                    </div>
                </div>
            </Reveal>
        </section>
    );
};
